/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'warrantyWater': {
    width: 15,
    height: 24,
    viewBox: '0 0 15 24',
    data: '<path pid="0" d="M7.5 20.997A4.508 4.508 0 013 16.494c0-.28.224-.5.5-.5s.5.22.5.5a3.505 3.505 0 003.5 3.503c.276 0 .5.22.5.5s-.224.5-.5.5zM7.937.24c-.176-.32-.698-.32-.874 0C6.775.75 0 12.95 0 16.494 0 20.637 3.364 24 7.5 24s7.5-3.363 7.5-7.506C15 12.95 8.225.75 7.937.24z" _fill="#FFF" fill-rule="evenodd"/>'
  }
})
